const INVALID_TIMEZONE_LABELS = new Set([
    'Time zone not found',
    'Time Zone Not Specified'
]);
export const isValidTimeZone = (value)=>{
    if (!value || typeof value !== 'string') {
        return false;
    }
    const timeZone = value.trim();
    if (!timeZone || INVALID_TIMEZONE_LABELS.has(timeZone)) {
        return false;
    }
    try {
        new Intl.DateTimeFormat('en-US', {
            timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
export const resolvePreferredTimeZone = (...candidates)=>{
    return candidates.find(isValidTimeZone);
};
export const resolveTimelineTimeZone = ({ caseRunTimeZone, activeCaseRunTimeZone, organizationTimeZone })=>{
    return resolvePreferredTimeZone(caseRunTimeZone, activeCaseRunTimeZone, organizationTimeZone);
};
